exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.el-tag[data-v-71cf32ba] {\n  vertical-align: top;\n}\n.el-tag + .el-tag[data-v-71cf32ba] {\n  margin-left: 5px;\n}\n.input-new-tag[data-v-71cf32ba] {\n  width: 90px;\n  margin-left: 5px;\n  vertical-align: bottom;\n}\n.color-picker[data-v-71cf32ba] {\n  left: 10px;\n  vertical-align: top;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-71cf32ba","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/avue/small-component/rate.vue
// module id = ZLgW
// module chunks = 289